// #TODO 30-04-2018_FG Terminer les interfaces

import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { ApiService } from 'libraries/service/api/api.service';
import { HotelResourceService } from 'libraries/service/resources/hotel/hotelResource.service';
import { IPrice, IDetail, IResortFeeDetail } from 'libraries/service/resources/model/search/IBooking';
import { ITotalCost } from '../models/hotel';
import { INotepad } from "libraries/service/resources/booking/interfaces/notepad.interface";
import { IEmergencyContact } from 'libraries/service/resources/hotel/hotel-quotation';
import { HttpClient } from '@angular/common/http';
import { IPostHotelBookingsCreateRequest } from "libraries/service/resources/hotel/IPostHotelBookingsCreate";

@Injectable()
export class BookingService extends ApiService {
    constructor(
        public http: HttpClient,
        private readonly hotelResourceService: HotelResourceService,
    ) { super(http); }

    public createRequest(quotation: any, requestPart: Partial<IPostHotelBookingsCreateRequest>, note?: INotepad[]): IPostHotelBookingsCreateRequest {
        const traveller: any = Object
            .keys(requestPart.travellers)
            .reduce(
                (travellerAccumulator: any, key: string) => ({
                    ...travellerAccumulator,
                    [key]: {
                        ...requestPart.travellers[key],
                        birthDate: !requestPart.travellers[key].birthDate ? null : moment(requestPart.travellers[key].birthDate).format('YYYY-MM-DD'),
                        passport: (!requestPart.travellers[key].passport || requestPart.travellers[key].passport.number === "")
                            ? null
                            : requestPart.travellers[key].passport
                    }
                }), requestPart.travellers
            );
        const request: IPostHotelBookingsCreateRequest = {
            host: quotation.quote.host,
            quote: {
                key: quotation.key
            },
            externalBooking: {
                owner: quotation.property[quotation.quote.property].owner,
                code: `${Math.round(+new Date() / 1000)}za${Math.round(Math.random() * 1e5)}`.substr(0, 20),
                role: "midOffice"
            },
            traveller,
            segmentNotUsed: quotation.segment,
            emergencyContact: requestPart.emergencyContact,
        };
        if (note.length !== 0) {
            request.remark = note;
        }


        // if (requestPart.remarks && requestPart.remarks.remark) {
        //     request.remark = requestPart.remarks.remark;
        // }

        return request;
    }

    public getBookingById(key: string): Observable<any> {
        return this.hotelResourceService.getBookingById(key);
    }

    public computeTotalCostFromDetails(price: IPrice): ITotalCost {
        const prices: Array<IDetail | IResortFeeDetail> = price.detail
            ? Array.isArray(price.detail) ? price.detail : [price.detail]
            : [];

        return prices
            .filter((detailPrice: IDetail) => detailPrice.included && detailPrice.total.cost)
            .map((detailPrice: IDetail): ITotalCost => detailPrice.total.cost)
            .reduce(
                (currentTotal: ITotalCost, oneTotal: ITotalCost): ITotalCost => {
                    return Object.keys(currentTotal)
                        .reduce((sum: ITotalCost, key: string): ITotalCost => ({
                            ...sum,
                            [key]: +sum[key] + (+oneTotal[key] || 0),
                        }),
                            currentTotal
                        );
                },
                {}
            ) || price.total.cost;
    }
}
